import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { UsersService } from '../services/users.service';
import { MenuItem } from '../types/menu-item.type';
import { MenuCardComponent } from '../menu-card/menu-card.component';
import { MatCardModule } from '@angular/material/card';
import { MenuService } from '../services/menu.service';
import { Router } from '@angular/router';
import { User } from '../models/user.model';
import { PermissionsService } from '../services/permissions.service';

@Component({
    selector: 'app-main-screen',
    standalone: true,
    imports: [
        MenuCardComponent,
        MatCardModule
    ],
    templateUrl: './main-screen.component.html',
    styleUrl: './main-screen.component.css'
})
export class MainScreenComponent implements OnInit {

  public user: any;

  constructor(
    private authService: AuthService,
    private userService: UsersService,
    public menuService: MenuService,
    public router: Router,
    private permissionsService: PermissionsService
  ) {
  }

  ngOnInit(): void {
      // this.authService.autoLogin();
      this.getLoggedUser();
  }

  getLoggedUser() {
    this.userService.getUserByToken()
    .subscribe({
      next: (response: any) => {
        console.log("next", response.user);

        this.authService.setUser(<User>response.user);
        this.user = response.user;
      },
      error: (error) => {
        console.log("error", error);
        if (error.status === 401) {
          this.authService.clearAuthData();
          this.router.navigate(['/']);
        }
      }
    });
  }

}
